export enum TakeOffUpdateStatus {
    StartPlanUpdated = 'startPlanUpdated',
    StartMeasurementsUpdated = 'startMeasurementsUpdated',
    Completed = 'Completed',
}
